module.exports = __webpack_public_path__ + "d6a38bc0.png";